// extracted by mini-css-extract-plugin
export default {"dot-position":"security_dot-position__yLYNb","dot":"security_dot__uOd-z","card-wrapper":"security_card-wrapper__MOiiy"};